// Tool registry — the extension point for the whole "collection".
//
// A tool is registered with:
//   id        unique key, also used as the path route (`/<id>`)
//   titleKey  i18n key for the card title
//   descKey   i18n key for the card description
//   iconText  short glyph/text shown in the card icon
//   loader    () => import('./<tool>/index.js') — resolved lazily so a tool's
//             heavy dependencies (AI/zip libs) are only loaded when opened.

const tools = [];

export function registerTool({ id, path, titleKey, descKey, iconTextKey, loader }) {
  tools.push({ id, path, titleKey, descKey, iconTextKey, loader });
}

export function listTools() {
  return tools;
}

export function getTool(id) {
  return tools.find((t) => t.id === id);
}
